import * as enumModels from './EnumModels';
import { StaffDevice, QuestionInsertUpdateRequest } from './RequestModels';
import { DateTime } from 'luxon';

export class BaseResponse {
    public HasError: boolean;
    public Errors: ErrorResponse[];
    public CreatedBy: string;
    public CreatedOn: Date;
    public ModifiedBy: string;
    public ModifiedOn: Date;

    public GetErrorMessage(): string {
        if (this.Errors != null && this.Errors.length > 0)
            return this.Errors[0].ErrorMessage;
        else
            return "";
    }
}

export class ErrorResponse {

    public ErrorCode: number;
    public ErrorMessage: string;
    public HasError: boolean;
}

export class ListResponse extends BaseResponse {
    public TotalRecords: number = 0;
    public CurrentPage: number = 1;
    public Result: any;
    public Headers: string[];
}

export class ArrayResponse<T = any> extends ListResponse {
    public Result: T[];
}

export class SimpleResponse<T = any> extends BaseResponse {
    public Result: T;
}

export class GuestLookup {
    public TritonReservationId: number;
    public GuestId: number;
    public FullName: string;
    public LocationDescription: string;
    public LocationId: number;
    public ReservationStatus: number;
    public Version: number;
    public PropertyId: number;
}

export class VisitorLookup {
    public VisitorName: string;
    public FName: string;
    public LName: string;
    public EmailId: string;
    public ContactNumber: string;
    public Id: number;
    public Title: string;
}

export class ReservationTrace {
    /** internal, added during api fetch*/
    public TraceUUID?: string
    public ReservationId: string;
    public TraceDate: Date;
    public TraceDepartment: string;
    public TraceText: string;
}

export class Staff_Search_Assigment {
    public StaffId: number;
    public DeptId: number;
    public DesgId: number;
    public OpenCalls: number;
    public IsLoggedIn: Boolean;
    public Sections: Array<number> = [];
    public Description: string = "";
    public Skills: Array<number> = [];
    public Designation: string;
    public Department: string;
    public AllOpenCalls: number;
}

export class ShiftSetupDepartmentData {
    public ActiveShiftId: number;
    public CurrentShift: ShiftDetails;
    public AllShifts: Array<ShiftDetails>;
    public DefaultStaffSkills: Array<ShiftStaff>;
    public ListShiftStaff: Array<ShiftStaff>;
    public ListStaffDevices: Array<StaffDevice>;
    public SectionLocations: Array<any>;
}
export class ShiftDetails {
    public ShiftId: number;
    public ShiftName: string;
    public Notes: string;
    public LanguageCode: string;
    public PerShiftSkillEnabled = false;
}
export class ShiftStaff {
    public ShiftId: number;
    public SectionId: number;
    public StaffId: number;
    public IsLoggedIn: boolean;
    public Skills: Array<number>;
}

export class ComplainGSRQuestions {
    public QuestionId: number;
    public Question: string;
    public IsCompulsory: boolean;
}

export class StaffQuestionaireTemplate {
    Id: number;
    ChainId: number;
    PropertyId: number;
    Status: enumModels.QuestionSetStatus;
    StatusClass?: string;
    TemplateName: string;
    CreatedOnUtc: string;
    CreatedOnDate: Date;
    CreatedById?: number;
    LastActivatedDateTimeUTC?: string;
    LastActivatedDate?: Date;
    LastDeactivatedDateTimeUTC?: string;
    LastDeactivatedDate?: Date;
    ExecutionCount = 0;
}

export class QuestionSetLookup {
    QuestionaireReponseCounts: QuestionnaireResponseCount[];
    StaffQuestionaireTemplates: StaffQuestionaireTemplate[];

}

export class QuestionnaireResponseCount {
    ResponseCount: number;
    QuestionaireId: number;
}

export class QuestionSetDetail {
    Questions: QuestionInsertUpdateRequest[];
    StaffQuestionaireTemplate: StaffQuestionaireTemplate;
}

export type QuestionSetLookupResponse = SimpleResponse<QuestionSetLookup>;

export type QuestionSetDetailResponse = SimpleResponse<QuestionSetDetail>;

export class StatusCodeCount {
    PropertyId: number;
    StatusCode: string;
    Count = 0;
}
